import { Modal, Button } from '@hotjar/hotsauce';
import { createGlobalModal } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';
import type { GlobalModalProps } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';

export interface RecordingSecureModalProps {
  organizationName: string;
}

export function RecordingSecureModal({
  organizationName,
  onSubmit,
}: RecordingSecureModalProps & GlobalModalProps<void, void>): JSX.Element {
  const title = 'Playing recording';
  const size = 's';

  return (
    <Modal onClose={onSubmit} contentLabel={title} isOpen size={size}>
      <Modal.Header title={title} />
      <Modal.Body>
        <p>
          The recording you are about to watch is only accessible by users who have access to{' '}
          {organizationName}.
        </p>
        <p>
          The link you are using to watch this recording is a temporary one which will expire within
          7 days of the notification email arriving in your inbox.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="primary" onClick={() => onSubmit()}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export const openRecordingSecureModal = createGlobalModal<RecordingSecureModalProps, void, void>(
  RecordingSecureModal,
);

export const showRecordingSecureModal = async (
  organizationName: string,
  onSubmit: () => void,
): Promise<void> => {
  try {
    await openRecordingSecureModal({ organizationName });
  } finally {
    onSubmit();
  }
};
